export type VfdCause = { cause: string; probability: number };

export type VfdFault = {
  id: string;
  category_id: string | null;
  device_ar: string;
  name_ar: string;
  description_ar: string;
  symptoms: string[];
  causes: VfdCause[];
  tests: { test: string; location: string; method: string; normal: string; faulty: string }[];
  solutions: string[];
  severity: string;
  safety_warnings: string[];
  error_code: string | null;
  keywords: string;
  next_question_key: string | null;
};

type Row = [string,string,string,string,string,VfdCause[],string[],string,string];

const C = (cause: string, probability: number): VfdCause => ({ cause, probability });

const rows: Row[] = [
  [
    "vfd-fault-001",
    "تغذية الـ VFD",
    "الـ VFD ما يشتغل نهائياً",
    "هذا العطل يخص تغذية الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "الـ VFD ما يشتغل نهائياً",
    [C("فولت التغذية أو الفازات مو طبيعية", 45), C("ربط أو قاطع أو فيوز بيه مشكلة", 35), C("مرحلة دخل الـ VFD متضررة", 20)],
    ["افحص فولت الدخول والفازات والقاطع والربطات.", "لا تعيد التشغيل إذا أكو فصل أو حرارة إلى أن ينفحص السبب."],
    "متوسطة",
    "VFD Inverter drive الـ VFD ما يشتغل نهائياً تغذية الـ VFD",
  ],
  [
    "vfd-fault-002",
    "تغذية الـ VFD",
    "فولت الدخول واطي",
    "هذا العطل يخص تغذية الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "فولت الدخول واطي",
    [C("فولت التغذية أو الفازات مو طبيعية", 45), C("ربط أو قاطع أو فيوز بيه مشكلة", 35), C("مرحلة دخل الـ VFD متضررة", 20)],
    ["افحص فولت الدخول والفازات والقاطع والربطات.", "لا تعيد التشغيل إذا أكو فصل أو حرارة إلى أن ينفحص السبب."],
    "متوسطة",
    "VFD Inverter drive فولت الدخول واطي تغذية الـ VFD",
  ],
  [
    "vfd-fault-003",
    "تغذية الـ VFD",
    "فولت الدخول عالي",
    "هذا العطل يخص تغذية الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "فولت الدخول عالي",
    [C("فولت التغذية أو الفازات مو طبيعية", 45), C("ربط أو قاطع أو فيوز بيه مشكلة", 35), C("مرحلة دخل الـ VFD متضررة", 20)],
    ["افحص فولت الدخول والفازات والقاطع والربطات.", "لا تعيد التشغيل إذا أكو فصل أو حرارة إلى أن ينفحص السبب."],
    "متوسطة",
    "VFD Inverter drive فولت الدخول عالي تغذية الـ VFD",
  ],
  [
    "vfd-fault-004",
    "تغذية الـ VFD",
    "فاز مفقود من دخل الـ VFD",
    "هذا العطل يخص تغذية الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "فاز مفقود من دخل الـ VFD",
    [C("فولت التغذية أو الفازات مو طبيعية", 45), C("ربط أو قاطع أو فيوز بيه مشكلة", 35), C("مرحلة دخل الـ VFD متضررة", 20)],
    ["افحص فولت الدخول والفازات والقاطع والربطات.", "لا تعيد التشغيل إذا أكو فصل أو حرارة إلى أن ينفحص السبب."],
    "متوسطة",
    "VFD Inverter drive فاز مفقود من دخل الـ VFD تغذية الـ VFD",
  ],
  [
    "vfd-fault-005",
    "تغذية الـ VFD",
    "الفولت بين الفازات مو متوازن",
    "هذا العطل يخص تغذية الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "الفولت بين الفازات مو متوازن",
    [C("فولت التغذية أو الفازات مو طبيعية", 45), C("ربط أو قاطع أو فيوز بيه مشكلة", 35), C("مرحلة دخل الـ VFD متضررة", 20)],
    ["افحص فولت الدخول والفازات والقاطع والربطات.", "لا تعيد التشغيل إذا أكو فصل أو حرارة إلى أن ينفحص السبب."],
    "متوسطة",
    "VFD Inverter drive الفولت بين الفازات مو متوازن تغذية الـ VFD",
  ],
  [
    "vfd-fault-006",
    "تغذية الـ VFD",
    "قاطع دخل الـ VFD يفصل",
    "هذا العطل يخص تغذية الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "قاطع دخل الـ VFD يفصل",
    [C("فولت التغذية أو الفازات مو طبيعية", 45), C("ربط أو قاطع أو فيوز بيه مشكلة", 35), C("مرحلة دخل الـ VFD متضررة", 20)],
    ["افحص فولت الدخول والفازات والقاطع والربطات.", "لا تعيد التشغيل إذا أكو فصل أو حرارة إلى أن ينفحص السبب."],
    "عالية",
    "VFD Inverter drive قاطع دخل الـ VFD يفصل تغذية الـ VFD",
  ],
  [
    "vfd-fault-007",
    "تغذية الـ VFD",
    "فيوزات الدخل تحترك باستمرار",
    "هذا العطل يخص تغذية الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "فيوزات الدخل تحترك باستمرار",
    [C("فولت التغذية أو الفازات مو طبيعية", 45), C("ربط أو قاطع أو فيوز بيه مشكلة", 35), C("مرحلة دخل الـ VFD متضررة", 20)],
    ["افحص فولت الدخول والفازات والقاطع والربطات.", "لا تعيد التشغيل إذا أكو فصل أو حرارة إلى أن ينفحص السبب."],
    "عالية",
    "VFD Inverter drive فيوزات الدخل تحترك باستمرار تغذية الـ VFD",
  ],
  [
    "vfd-fault-008",
    "تغذية الـ VFD",
    "كونتاكتور الدخل يقطع",
    "هذا العطل يخص تغذية الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "كونتاكتور الدخل يقطع",
    [C("فولت التغذية أو الفازات مو طبيعية", 45), C("ربط أو قاطع أو فيوز بيه مشكلة", 35), C("مرحلة دخل الـ VFD متضررة", 20)],
    ["افحص فولت الدخول والفازات والقاطع والربطات.", "لا تعيد التشغيل إذا أكو فصل أو حرارة إلى أن ينفحص السبب."],
    "متوسطة",
    "VFD Inverter drive كونتاكتور الدخل يقطع تغذية الـ VFD",
  ],
  [
    "vfd-fault-009",
    "تغذية الـ VFD",
    "ترمنل دخل الـ VFD حرارته ترتفع",
    "هذا العطل يخص تغذية الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "ترمنل دخل الـ VFD حرارته ترتفع",
    [C("فولت التغذية أو الفازات مو طبيعية", 45), C("ربط أو قاطع أو فيوز بيه مشكلة", 35), C("مرحلة دخل الـ VFD متضررة", 20)],
    ["افحص فولت الدخول والفازات والقاطع والربطات.", "لا تعيد التشغيل إذا أكو فصل أو حرارة إلى أن ينفحص السبب."],
    "متوسطة",
    "VFD Inverter drive ترمنل دخل الـ VFD حرارته ترتفع تغذية الـ VFD",
  ],
  [
    "vfd-fault-010",
    "تغذية الـ VFD",
    "الـ VFD يفصل من يصير هبوط لحظي بالشبكة",
    "هذا العطل يخص تغذية الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "الـ VFD يفصل من يصير هبوط لحظي بالشبكة",
    [C("فولت التغذية أو الفازات مو طبيعية", 45), C("ربط أو قاطع أو فيوز بيه مشكلة", 35), C("مرحلة دخل الـ VFD متضررة", 20)],
    ["افحص فولت الدخول والفازات والقاطع والربطات.", "لا تعيد التشغيل إذا أكو فصل أو حرارة إلى أن ينفحص السبب."],
    "متوسطة",
    "VFD Inverter drive الـ VFD يفصل من يصير هبوط لحظي بالشبكة تغذية الـ VFD",
  ],
  [
    "vfd-fault-011",
    "DC Bus / Precharge",
    "فولت الـ DC Bus ما يرتفع",
    "هذا العطل يخص DC Bus / Precharge ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "فولت الـ DC Bus ما يرتفع",
    [C("دائرة الـ Rectifier أو Precharge بيها مشكلة", 45), C("مكثفات الـ DC Bus ضعيفة أو متضررة", 35), C("فولت الشبكة أو الحمل يسبب الباص يطلع خارج الحد", 20)],
    ["افصل التغذية وانتظر زمن تفريغ الـ DC Bus حسب المصنع.", "خلي فني مختص يفحص الـ Rectifier والـ Precharge والمكثفات."],
    "عالية",
    "VFD Inverter drive فولت الـ DC Bus ما يرتفع DC Bus / Precharge",
  ],
  [
    "vfd-fault-012",
    "DC Bus / Precharge",
    "فولت الـ DC Bus عالي",
    "هذا العطل يخص DC Bus / Precharge ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "فولت الـ DC Bus عالي",
    [C("دائرة الـ Rectifier أو Precharge بيها مشكلة", 45), C("مكثفات الـ DC Bus ضعيفة أو متضررة", 35), C("فولت الشبكة أو الحمل يسبب الباص يطلع خارج الحد", 20)],
    ["افصل التغذية وانتظر زمن تفريغ الـ DC Bus حسب المصنع.", "خلي فني مختص يفحص الـ Rectifier والـ Precharge والمكثفات."],
    "عالية",
    "VFD Inverter drive فولت الـ DC Bus عالي DC Bus / Precharge",
  ],
  [
    "vfd-fault-013",
    "DC Bus / Precharge",
    "فولت الـ DC Bus يتذبذب",
    "هذا العطل يخص DC Bus / Precharge ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "فولت الـ DC Bus يتذبذب",
    [C("دائرة الـ Rectifier أو Precharge بيها مشكلة", 45), C("مكثفات الـ DC Bus ضعيفة أو متضررة", 35), C("فولت الشبكة أو الحمل يسبب الباص يطلع خارج الحد", 20)],
    ["افصل التغذية وانتظر زمن تفريغ الـ DC Bus حسب المصنع.", "خلي فني مختص يفحص الـ Rectifier والـ Precharge والمكثفات."],
    "عالية",
    "VFD Inverter drive فولت الـ DC Bus يتذبذب DC Bus / Precharge",
  ],
  [
    "vfd-fault-014",
    "DC Bus / Precharge",
    "مقاومة الـ Precharge متضررة",
    "هذا العطل يخص DC Bus / Precharge ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "مقاومة الـ Precharge متضررة",
    [C("دائرة الـ Rectifier أو Precharge بيها مشكلة", 45), C("مكثفات الـ DC Bus ضعيفة أو متضررة", 35), C("فولت الشبكة أو الحمل يسبب الباص يطلع خارج الحد", 20)],
    ["افصل التغذية وانتظر زمن تفريغ الـ DC Bus حسب المصنع.", "خلي فني مختص يفحص الـ Rectifier والـ Precharge والمكثفات."],
    "عالية",
    "VFD Inverter drive مقاومة الـ Precharge متضررة DC Bus / Precharge",
  ],
  [
    "vfd-fault-015",
    "DC Bus / Precharge",
    "ريليه الـ Precharge ما يغلق",
    "هذا العطل يخص DC Bus / Precharge ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "ريليه الـ Precharge ما يغلق",
    [C("دائرة الـ Rectifier أو Precharge بيها مشكلة", 45), C("مكثفات الـ DC Bus ضعيفة أو متضررة", 35), C("فولت الشبكة أو الحمل يسبب الباص يطلع خارج الحد", 20)],
    ["افصل التغذية وانتظر زمن تفريغ الـ DC Bus حسب المصنع.", "خلي فني مختص يفحص الـ Rectifier والـ Precharge والمكثفات."],
    "عالية",
    "VFD Inverter drive ريليه الـ Precharge ما يغلق DC Bus / Precharge",
  ],
  [
    "vfd-fault-016",
    "DC Bus / Precharge",
    "مكثفات الـ DC Bus ضعفت",
    "هذا العطل يخص DC Bus / Precharge ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "مكثفات الـ DC Bus ضعفت",
    [C("دائرة الـ Rectifier أو Precharge بيها مشكلة", 45), C("مكثفات الـ DC Bus ضعيفة أو متضررة", 35), C("فولت الشبكة أو الحمل يسبب الباص يطلع خارج الحد", 20)],
    ["افصل التغذية وانتظر زمن تفريغ الـ DC Bus حسب المصنع.", "خلي فني مختص يفحص الـ Rectifier والـ Precharge والمكثفات."],
    "عالية",
    "VFD Inverter drive مكثفات الـ DC Bus ضعفت DC Bus / Precharge",
  ],
  [
    "vfd-fault-017",
    "DC Bus / Precharge",
    "مكثف الـ DC Bus منتفخ أو يسرب",
    "هذا العطل يخص DC Bus / Precharge ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "مكثف الـ DC Bus منتفخ أو يسرب",
    [C("دائرة الـ Rectifier أو Precharge بيها مشكلة", 45), C("مكثفات الـ DC Bus ضعيفة أو متضررة", 35), C("فولت الشبكة أو الحمل يسبب الباص يطلع خارج الحد", 20)],
    ["افصل التغذية وانتظر زمن تفريغ الـ DC Bus حسب المصنع.", "خلي فني مختص يفحص الـ Rectifier والـ Precharge والمكثفات."],
    "عالية",
    "VFD Inverter drive مكثف الـ DC Bus منتفخ أو يسرب DC Bus / Precharge",
  ],
  [
    "vfd-fault-018",
    "DC Bus / Precharge",
    "الـ DC Bus ما يفرغ بعد الفصل بالوقت الطبيعي",
    "هذا العطل يخص DC Bus / Precharge ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "الـ DC Bus ما يفرغ بعد الفصل بالوقت الطبيعي",
    [C("دائرة الـ Rectifier أو Precharge بيها مشكلة", 45), C("مكثفات الـ DC Bus ضعيفة أو متضررة", 35), C("فولت الشبكة أو الحمل يسبب الباص يطلع خارج الحد", 20)],
    ["افصل التغذية وانتظر زمن تفريغ الـ DC Bus حسب المصنع.", "خلي فني مختص يفحص الـ Rectifier والـ Precharge والمكثفات."],
    "عالية",
    "VFD Inverter drive الـ DC Bus ما يفرغ بعد الفصل بالوقت الطبيعي DC Bus / Precharge",
  ],
  [
    "vfd-fault-019",
    "DC Bus / Precharge",
    "الدرايف يطلع DC Bus Undervoltage تحت الحمل",
    "هذا العطل يخص DC Bus / Precharge ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "الدرايف يطلع DC Bus Undervoltage تحت الحمل",
    [C("دائرة الـ Rectifier أو Precharge بيها مشكلة", 45), C("مكثفات الـ DC Bus ضعيفة أو متضررة", 35), C("فولت الشبكة أو الحمل يسبب الباص يطلع خارج الحد", 20)],
    ["افصل التغذية وانتظر زمن تفريغ الـ DC Bus حسب المصنع.", "خلي فني مختص يفحص الـ Rectifier والـ Precharge والمكثفات."],
    "عالية",
    "VFD Inverter drive الدرايف يطلع DC Bus Undervoltage تحت الحمل DC Bus / Precharge",
  ],
  [
    "vfd-fault-020",
    "DC Bus / Precharge",
    "الدرايف يطلع DC Bus Overvoltage بدون تباطؤ قوي",
    "هذا العطل يخص DC Bus / Precharge ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "الدرايف يطلع DC Bus Overvoltage بدون تباطؤ قوي",
    [C("دائرة الـ Rectifier أو Precharge بيها مشكلة", 45), C("مكثفات الـ DC Bus ضعيفة أو متضررة", 35), C("فولت الشبكة أو الحمل يسبب الباص يطلع خارج الحد", 20)],
    ["افصل التغذية وانتظر زمن تفريغ الـ DC Bus حسب المصنع.", "خلي فني مختص يفحص الـ Rectifier والـ Precharge والمكثفات."],
    "عالية",
    "VFD Inverter drive الدرايف يطلع DC Bus Overvoltage بدون تباطؤ قوي DC Bus / Precharge",
  ],
  [
    "vfd-fault-021",
    "Braking / Deceleration",
    "مقاومة الفرملة حرارتها ترتفع",
    "هذا العطل يخص Braking / Deceleration ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "مقاومة الفرملة حرارتها ترتفع",
    [C("زمن التباطؤ مو مناسب للحمل", 45), C("مقاومة الفرملة أو الـ Chopper بيه عطل", 35), C("الحمل يرجع طاقة عالية للـ DC Bus", 20)],
    ["راجع زمن Decel وقيمة مقاومة الفرملة حسب التطبيق.", "افحص الـ Braking Resistor والـ Chopper بواسطة فني مختص."],
    "متوسطة",
    "VFD Inverter drive مقاومة الفرملة حرارتها ترتفع Braking / Deceleration",
  ],
  [
    "vfd-fault-022",
    "Braking / Deceleration",
    "مقاومة الفرملة مفتوحة",
    "هذا العطل يخص Braking / Deceleration ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "مقاومة الفرملة مفتوحة",
    [C("زمن التباطؤ مو مناسب للحمل", 45), C("مقاومة الفرملة أو الـ Chopper بيه عطل", 35), C("الحمل يرجع طاقة عالية للـ DC Bus", 20)],
    ["راجع زمن Decel وقيمة مقاومة الفرملة حسب التطبيق.", "افحص الـ Braking Resistor والـ Chopper بواسطة فني مختص."],
    "متوسطة",
    "VFD Inverter drive مقاومة الفرملة مفتوحة Braking / Deceleration",
  ],
  [
    "vfd-fault-023",
    "Braking / Deceleration",
    "Braking Chopper ما يشتغل",
    "هذا العطل يخص Braking / Deceleration ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Braking Chopper ما يشتغل",
    [C("زمن التباطؤ مو مناسب للحمل", 45), C("مقاومة الفرملة أو الـ Chopper بيه عطل", 35), C("الحمل يرجع طاقة عالية للـ DC Bus", 20)],
    ["راجع زمن Decel وقيمة مقاومة الفرملة حسب التطبيق.", "افحص الـ Braking Resistor والـ Chopper بواسطة فني مختص."],
    "متوسطة",
    "VFD Inverter drive Braking Chopper ما يشتغل Braking / Deceleration",
  ],
  [
    "vfd-fault-024",
    "Braking / Deceleration",
    "Braking Chopper صار شورت",
    "هذا العطل يخص Braking / Deceleration ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Braking Chopper صار شورت",
    [C("زمن التباطؤ مو مناسب للحمل", 45), C("مقاومة الفرملة أو الـ Chopper بيه عطل", 35), C("الحمل يرجع طاقة عالية للـ DC Bus", 20)],
    ["راجع زمن Decel وقيمة مقاومة الفرملة حسب التطبيق.", "افحص الـ Braking Resistor والـ Chopper بواسطة فني مختص."],
    "حرجة",
    "VFD Inverter drive Braking Chopper صار شورت Braking / Deceleration",
  ],
  [
    "vfd-fault-025",
    "Braking / Deceleration",
    "Overvoltage وقت التباطؤ",
    "هذا العطل يخص Braking / Deceleration ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Overvoltage وقت التباطؤ",
    [C("زمن التباطؤ مو مناسب للحمل", 45), C("مقاومة الفرملة أو الـ Chopper بيه عطل", 35), C("الحمل يرجع طاقة عالية للـ DC Bus", 20)],
    ["راجع زمن Decel وقيمة مقاومة الفرملة حسب التطبيق.", "افحص الـ Braking Resistor والـ Chopper بواسطة فني مختص."],
    "عالية",
    "VFD Inverter drive Overvoltage وقت التباطؤ Braking / Deceleration",
  ],
  [
    "vfd-fault-026",
    "Braking / Deceleration",
    "المحرك ما يوقف بسرعة كافية",
    "هذا العطل يخص Braking / Deceleration ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "المحرك ما يوقف بسرعة كافية",
    [C("زمن التباطؤ مو مناسب للحمل", 45), C("مقاومة الفرملة أو الـ Chopper بيه عطل", 35), C("الحمل يرجع طاقة عالية للـ DC Bus", 20)],
    ["راجع زمن Decel وقيمة مقاومة الفرملة حسب التطبيق.", "افحص الـ Braking Resistor والـ Chopper بواسطة فني مختص."],
    "متوسطة",
    "VFD Inverter drive المحرك ما يوقف بسرعة كافية Braking / Deceleration",
  ],
  [
    "vfd-fault-027",
    "Braking / Deceleration",
    "DC Injection Brake ما يشتغل",
    "هذا العطل يخص Braking / Deceleration ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "DC Injection Brake ما يشتغل",
    [C("زمن التباطؤ مو مناسب للحمل", 45), C("مقاومة الفرملة أو الـ Chopper بيه عطل", 35), C("الحمل يرجع طاقة عالية للـ DC Bus", 20)],
    ["راجع زمن Decel وقيمة مقاومة الفرملة حسب التطبيق.", "افحص الـ Braking Resistor والـ Chopper بواسطة فني مختص."],
    "متوسطة",
    "VFD Inverter drive DC Injection Brake ما يشتغل Braking / Deceleration",
  ],
  [
    "vfd-fault-028",
    "Braking / Deceleration",
    "DC Injection Brake قوي ويسبب حرارة بالمحرك",
    "هذا العطل يخص Braking / Deceleration ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "DC Injection Brake قوي ويسبب حرارة بالمحرك",
    [C("زمن التباطؤ مو مناسب للحمل", 45), C("مقاومة الفرملة أو الـ Chopper بيه عطل", 35), C("الحمل يرجع طاقة عالية للـ DC Bus", 20)],
    ["راجع زمن Decel وقيمة مقاومة الفرملة حسب التطبيق.", "افحص الـ Braking Resistor والـ Chopper بواسطة فني مختص."],
    "عالية",
    "VFD Inverter drive DC Injection Brake قوي ويسبب حرارة بالمحرك Braking / Deceleration",
  ],
  [
    "vfd-fault-029",
    "Braking / Deceleration",
    "زمن التباطؤ قصير زيادة",
    "هذا العطل يخص Braking / Deceleration ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "زمن التباطؤ قصير زيادة",
    [C("زمن التباطؤ مو مناسب للحمل", 45), C("مقاومة الفرملة أو الـ Chopper بيه عطل", 35), C("الحمل يرجع طاقة عالية للـ DC Bus", 20)],
    ["راجع زمن Decel وقيمة مقاومة الفرملة حسب التطبيق.", "افحص الـ Braking Resistor والـ Chopper بواسطة فني مختص."],
    "متوسطة",
    "VFD Inverter drive زمن التباطؤ قصير زيادة Braking / Deceleration",
  ],
  [
    "vfd-fault-030",
    "Braking / Deceleration",
    "زمن التباطؤ طويل زيادة",
    "هذا العطل يخص Braking / Deceleration ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "زمن التباطؤ طويل زيادة",
    [C("زمن التباطؤ مو مناسب للحمل", 45), C("مقاومة الفرملة أو الـ Chopper بيه عطل", 35), C("الحمل يرجع طاقة عالية للـ DC Bus", 20)],
    ["راجع زمن Decel وقيمة مقاومة الفرملة حسب التطبيق.", "افحص الـ Braking Resistor والـ Chopper بواسطة فني مختص."],
    "متوسطة",
    "VFD Inverter drive زمن التباطؤ طويل زيادة Braking / Deceleration",
  ],
  [
    "vfd-fault-031",
    "مرحلة القدرة IGBT",
    "عطل IGBT بمرحلة الخرج",
    "هذا العطل يخص مرحلة القدرة IGBT ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "عطل IGBT بمرحلة الخرج",
    [C("IGBT أو Gate Driver متضرر", 45), C("المحرك أو كيبل الخرج بيه شورت أو تسريب", 35), C("حرارة أو نبضة كهربائية سببت ضرر بمرحلة القدرة", 20)],
    ["خلي الدرايف مفصول ولا تعيد Reset بصورة متكررة.", "افحص المحرك والكيبل ثم مرحلة القدرة بواسطة مختص."],
    "حرجة",
    "VFD Inverter drive عطل IGBT بمرحلة الخرج مرحلة القدرة IGBT",
  ],
  [
    "vfd-fault-032",
    "مرحلة القدرة IGBT",
    "الدرايف يطلع Short Circuit Fault",
    "هذا العطل يخص مرحلة القدرة IGBT ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "الدرايف يطلع Short Circuit Fault",
    [C("IGBT أو Gate Driver متضرر", 45), C("المحرك أو كيبل الخرج بيه شورت أو تسريب", 35), C("حرارة أو نبضة كهربائية سببت ضرر بمرحلة القدرة", 20)],
    ["خلي الدرايف مفصول ولا تعيد Reset بصورة متكررة.", "افحص المحرك والكيبل ثم مرحلة القدرة بواسطة مختص."],
    "عالية",
    "VFD Inverter drive الدرايف يطلع Short Circuit Fault مرحلة القدرة IGBT",
  ],
  [
    "vfd-fault-033",
    "مرحلة القدرة IGBT",
    "الدرايف يطلع Ground Fault",
    "هذا العطل يخص مرحلة القدرة IGBT ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "الدرايف يطلع Ground Fault",
    [C("IGBT أو Gate Driver متضرر", 45), C("المحرك أو كيبل الخرج بيه شورت أو تسريب", 35), C("حرارة أو نبضة كهربائية سببت ضرر بمرحلة القدرة", 20)],
    ["خلي الدرايف مفصول ولا تعيد Reset بصورة متكررة.", "افحص المحرك والكيبل ثم مرحلة القدرة بواسطة مختص."],
    "حرجة",
    "VFD Inverter drive الدرايف يطلع Ground Fault مرحلة القدرة IGBT",
  ],
  [
    "vfd-fault-034",
    "مرحلة القدرة IGBT",
    "فاز خرج مفقود",
    "هذا العطل يخص مرحلة القدرة IGBT ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "فاز خرج مفقود",
    [C("IGBT أو Gate Driver متضرر", 45), C("المحرك أو كيبل الخرج بيه شورت أو تسريب", 35), C("حرارة أو نبضة كهربائية سببت ضرر بمرحلة القدرة", 20)],
    ["خلي الدرايف مفصول ولا تعيد Reset بصورة متكررة.", "افحص المحرك والكيبل ثم مرحلة القدرة بواسطة مختص."],
    "عالية",
    "VFD Inverter drive فاز خرج مفقود مرحلة القدرة IGBT",
  ],
  [
    "vfd-fault-035",
    "مرحلة القدرة IGBT",
    "التيار بين U V W مو متوازن",
    "هذا العطل يخص مرحلة القدرة IGBT ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "التيار بين U V W مو متوازن",
    [C("IGBT أو Gate Driver متضرر", 45), C("المحرك أو كيبل الخرج بيه شورت أو تسريب", 35), C("حرارة أو نبضة كهربائية سببت ضرر بمرحلة القدرة", 20)],
    ["خلي الدرايف مفصول ولا تعيد Reset بصورة متكررة.", "افحص المحرك والكيبل ثم مرحلة القدرة بواسطة مختص."],
    "عالية",
    "VFD Inverter drive التيار بين U V W مو متوازن مرحلة القدرة IGBT",
  ],
  [
    "vfd-fault-036",
    "مرحلة القدرة IGBT",
    "Gate Driver متضرر",
    "هذا العطل يخص مرحلة القدرة IGBT ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Gate Driver متضرر",
    [C("IGBT أو Gate Driver متضرر", 45), C("المحرك أو كيبل الخرج بيه شورت أو تسريب", 35), C("حرارة أو نبضة كهربائية سببت ضرر بمرحلة القدرة", 20)],
    ["خلي الدرايف مفصول ولا تعيد Reset بصورة متكررة.", "افحص المحرك والكيبل ثم مرحلة القدرة بواسطة مختص."],
    "عالية",
    "VFD Inverter drive Gate Driver متضرر مرحلة القدرة IGBT",
  ],
  [
    "vfd-fault-037",
    "مرحلة القدرة IGBT",
    "مرحلة خرج وحدة حرارتها ترتفع",
    "هذا العطل يخص مرحلة القدرة IGBT ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "مرحلة خرج وحدة حرارتها ترتفع",
    [C("IGBT أو Gate Driver متضرر", 45), C("المحرك أو كيبل الخرج بيه شورت أو تسريب", 35), C("حرارة أو نبضة كهربائية سببت ضرر بمرحلة القدرة", 20)],
    ["خلي الدرايف مفصول ولا تعيد Reset بصورة متكررة.", "افحص المحرك والكيبل ثم مرحلة القدرة بواسطة مختص."],
    "عالية",
    "VFD Inverter drive مرحلة خرج وحدة حرارتها ترتفع مرحلة القدرة IGBT",
  ],
  [
    "vfd-fault-038",
    "مرحلة القدرة IGBT",
    "فيوز داخلي بمرحلة القدرة فاصل",
    "هذا العطل يخص مرحلة القدرة IGBT ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "فيوز داخلي بمرحلة القدرة فاصل",
    [C("IGBT أو Gate Driver متضرر", 45), C("المحرك أو كيبل الخرج بيه شورت أو تسريب", 35), C("حرارة أو نبضة كهربائية سببت ضرر بمرحلة القدرة", 20)],
    ["خلي الدرايف مفصول ولا تعيد Reset بصورة متكررة.", "افحص المحرك والكيبل ثم مرحلة القدرة بواسطة مختص."],
    "عالية",
    "VFD Inverter drive فيوز داخلي بمرحلة القدرة فاصل مرحلة القدرة IGBT",
  ],
  [
    "vfd-fault-039",
    "مرحلة القدرة IGBT",
    "الدرايف يفصل فور ربط المحرك",
    "هذا العطل يخص مرحلة القدرة IGBT ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "الدرايف يفصل فور ربط المحرك",
    [C("IGBT أو Gate Driver متضرر", 45), C("المحرك أو كيبل الخرج بيه شورت أو تسريب", 35), C("حرارة أو نبضة كهربائية سببت ضرر بمرحلة القدرة", 20)],
    ["خلي الدرايف مفصول ولا تعيد Reset بصورة متكررة.", "افحص المحرك والكيبل ثم مرحلة القدرة بواسطة مختص."],
    "عالية",
    "VFD Inverter drive الدرايف يفصل فور ربط المحرك مرحلة القدرة IGBT",
  ],
  [
    "vfd-fault-040",
    "مرحلة القدرة IGBT",
    "الدرايف يفصل حتى والمحرك مفصول",
    "هذا العطل يخص مرحلة القدرة IGBT ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "الدرايف يفصل حتى والمحرك مفصول",
    [C("IGBT أو Gate Driver متضرر", 45), C("المحرك أو كيبل الخرج بيه شورت أو تسريب", 35), C("حرارة أو نبضة كهربائية سببت ضرر بمرحلة القدرة", 20)],
    ["خلي الدرايف مفصول ولا تعيد Reset بصورة متكررة.", "افحص المحرك والكيبل ثم مرحلة القدرة بواسطة مختص."],
    "عالية",
    "VFD Inverter drive الدرايف يفصل حتى والمحرك مفصول مرحلة القدرة IGBT",
  ],
  [
    "vfd-fault-041",
    "المحرك وخرج الـ VFD",
    "Overcurrent وقت البدء",
    "هذا العطل يخص المحرك وخرج الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Overcurrent وقت البدء",
    [C("الحمل أعلى من الطبيعي", 45), C("بيانات المحرك أو إعدادات التحكم مو صحيحة", 35), C("المحرك أو كيبل U/V/W بيه مشكلة", 20)],
    ["راجع تيار الحمل وبيانات لوحة المحرك.", "افحص U/V/W والمحرك وإعدادات الحماية والتحكم."],
    "عالية",
    "VFD Inverter drive Overcurrent وقت البدء المحرك وخرج الـ VFD",
  ],
  [
    "vfd-fault-042",
    "المحرك وخرج الـ VFD",
    "Overcurrent وقت التباطؤ",
    "هذا العطل يخص المحرك وخرج الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Overcurrent وقت التباطؤ",
    [C("الحمل أعلى من الطبيعي", 45), C("بيانات المحرك أو إعدادات التحكم مو صحيحة", 35), C("المحرك أو كيبل U/V/W بيه مشكلة", 20)],
    ["راجع تيار الحمل وبيانات لوحة المحرك.", "افحص U/V/W والمحرك وإعدادات الحماية والتحكم."],
    "عالية",
    "VFD Inverter drive Overcurrent وقت التباطؤ المحرك وخرج الـ VFD",
  ],
  [
    "vfd-fault-043",
    "المحرك وخرج الـ VFD",
    "Overcurrent أثناء السرعة الثابتة",
    "هذا العطل يخص المحرك وخرج الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Overcurrent أثناء السرعة الثابتة",
    [C("الحمل أعلى من الطبيعي", 45), C("بيانات المحرك أو إعدادات التحكم مو صحيحة", 35), C("المحرك أو كيبل U/V/W بيه مشكلة", 20)],
    ["راجع تيار الحمل وبيانات لوحة المحرك.", "افحص U/V/W والمحرك وإعدادات الحماية والتحكم."],
    "عالية",
    "VFD Inverter drive Overcurrent أثناء السرعة الثابتة المحرك وخرج الـ VFD",
  ],
  [
    "vfd-fault-044",
    "المحرك وخرج الـ VFD",
    "Motor Overload",
    "هذا العطل يخص المحرك وخرج الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Motor Overload",
    [C("الحمل أعلى من الطبيعي", 45), C("بيانات المحرك أو إعدادات التحكم مو صحيحة", 35), C("المحرك أو كيبل U/V/W بيه مشكلة", 20)],
    ["راجع تيار الحمل وبيانات لوحة المحرك.", "افحص U/V/W والمحرك وإعدادات الحماية والتحكم."],
    "متوسطة",
    "VFD Inverter drive Motor Overload المحرك وخرج الـ VFD",
  ],
  [
    "vfd-fault-045",
    "المحرك وخرج الـ VFD",
    "Drive Overload",
    "هذا العطل يخص المحرك وخرج الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Drive Overload",
    [C("الحمل أعلى من الطبيعي", 45), C("بيانات المحرك أو إعدادات التحكم مو صحيحة", 35), C("المحرك أو كيبل U/V/W بيه مشكلة", 20)],
    ["راجع تيار الحمل وبيانات لوحة المحرك.", "افحص U/V/W والمحرك وإعدادات الحماية والتحكم."],
    "متوسطة",
    "VFD Inverter drive Drive Overload المحرك وخرج الـ VFD",
  ],
  [
    "vfd-fault-046",
    "المحرك وخرج الـ VFD",
    "عزم المحرك ضعيف على السرعة الواطية",
    "هذا العطل يخص المحرك وخرج الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "عزم المحرك ضعيف على السرعة الواطية",
    [C("الحمل أعلى من الطبيعي", 45), C("بيانات المحرك أو إعدادات التحكم مو صحيحة", 35), C("المحرك أو كيبل U/V/W بيه مشكلة", 20)],
    ["راجع تيار الحمل وبيانات لوحة المحرك.", "افحص U/V/W والمحرك وإعدادات الحماية والتحكم."],
    "متوسطة",
    "VFD Inverter drive عزم المحرك ضعيف على السرعة الواطية المحرك وخرج الـ VFD",
  ],
  [
    "vfd-fault-047",
    "المحرك وخرج الـ VFD",
    "عزم المحرك قوي زيادة ويسبب صدمة",
    "هذا العطل يخص المحرك وخرج الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "عزم المحرك قوي زيادة ويسبب صدمة",
    [C("الحمل أعلى من الطبيعي", 45), C("بيانات المحرك أو إعدادات التحكم مو صحيحة", 35), C("المحرك أو كيبل U/V/W بيه مشكلة", 20)],
    ["راجع تيار الحمل وبيانات لوحة المحرك.", "افحص U/V/W والمحرك وإعدادات الحماية والتحكم."],
    "متوسطة",
    "VFD Inverter drive عزم المحرك قوي زيادة ويسبب صدمة المحرك وخرج الـ VFD",
  ],
  [
    "vfd-fault-048",
    "المحرك وخرج الـ VFD",
    "سرعة المحرك أقل من الأمر",
    "هذا العطل يخص المحرك وخرج الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "سرعة المحرك أقل من الأمر",
    [C("الحمل أعلى من الطبيعي", 45), C("بيانات المحرك أو إعدادات التحكم مو صحيحة", 35), C("المحرك أو كيبل U/V/W بيه مشكلة", 20)],
    ["راجع تيار الحمل وبيانات لوحة المحرك.", "افحص U/V/W والمحرك وإعدادات الحماية والتحكم."],
    "متوسطة",
    "VFD Inverter drive سرعة المحرك أقل من الأمر المحرك وخرج الـ VFD",
  ],
  [
    "vfd-fault-049",
    "المحرك وخرج الـ VFD",
    "سرعة المحرك أعلى من الأمر",
    "هذا العطل يخص المحرك وخرج الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "سرعة المحرك أعلى من الأمر",
    [C("الحمل أعلى من الطبيعي", 45), C("بيانات المحرك أو إعدادات التحكم مو صحيحة", 35), C("المحرك أو كيبل U/V/W بيه مشكلة", 20)],
    ["راجع تيار الحمل وبيانات لوحة المحرك.", "افحص U/V/W والمحرك وإعدادات الحماية والتحكم."],
    "متوسطة",
    "VFD Inverter drive سرعة المحرك أعلى من الأمر المحرك وخرج الـ VFD",
  ],
  [
    "vfd-fault-050",
    "المحرك وخرج الـ VFD",
    "سرعة المحرك تتذبذب",
    "هذا العطل يخص المحرك وخرج الـ VFD ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "سرعة المحرك تتذبذب",
    [C("الحمل أعلى من الطبيعي", 45), C("بيانات المحرك أو إعدادات التحكم مو صحيحة", 35), C("المحرك أو كيبل U/V/W بيه مشكلة", 20)],
    ["راجع تيار الحمل وبيانات لوحة المحرك.", "افحص U/V/W والمحرك وإعدادات الحماية والتحكم."],
    "متوسطة",
    "VFD Inverter drive سرعة المحرك تتذبذب المحرك وخرج الـ VFD",
  ],
  [
    "vfd-fault-051",
    "التسارع والسرعة",
    "المحرك ما يوصل للسرعة المطلوبة",
    "هذا العطل يخص التسارع والسرعة ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "المحرك ما يوصل للسرعة المطلوبة",
    [C("Limits أو Accel/Decel مو مضبوطة", 45), C("الحمل يحتاج عزم أعلى من المتوفر", 35), C("إعدادات السرعة أو Current/Torque Limit مأثرة", 20)],
    ["راجع Accel/Decel والـ Limits والـ Current/Torque Limit.", "افحص الحمل قبل رفع أي Limits."],
    "متوسطة",
    "VFD Inverter drive المحرك ما يوصل للسرعة المطلوبة التسارع والسرعة",
  ],
  [
    "vfd-fault-052",
    "التسارع والسرعة",
    "زمن التسارع طويل زيادة",
    "هذا العطل يخص التسارع والسرعة ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "زمن التسارع طويل زيادة",
    [C("Limits أو Accel/Decel مو مضبوطة", 45), C("الحمل يحتاج عزم أعلى من المتوفر", 35), C("إعدادات السرعة أو Current/Torque Limit مأثرة", 20)],
    ["راجع Accel/Decel والـ Limits والـ Current/Torque Limit.", "افحص الحمل قبل رفع أي Limits."],
    "متوسطة",
    "VFD Inverter drive زمن التسارع طويل زيادة التسارع والسرعة",
  ],
  [
    "vfd-fault-053",
    "التسارع والسرعة",
    "زمن التسارع قصير زيادة",
    "هذا العطل يخص التسارع والسرعة ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "زمن التسارع قصير زيادة",
    [C("Limits أو Accel/Decel مو مضبوطة", 45), C("الحمل يحتاج عزم أعلى من المتوفر", 35), C("إعدادات السرعة أو Current/Torque Limit مأثرة", 20)],
    ["راجع Accel/Decel والـ Limits والـ Current/Torque Limit.", "افحص الحمل قبل رفع أي Limits."],
    "متوسطة",
    "VFD Inverter drive زمن التسارع قصير زيادة التسارع والسرعة",
  ],
  [
    "vfd-fault-054",
    "التسارع والسرعة",
    "Current Limit يمنع زيادة السرعة",
    "هذا العطل يخص التسارع والسرعة ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Current Limit يمنع زيادة السرعة",
    [C("Limits أو Accel/Decel مو مضبوطة", 45), C("الحمل يحتاج عزم أعلى من المتوفر", 35), C("إعدادات السرعة أو Current/Torque Limit مأثرة", 20)],
    ["راجع Accel/Decel والـ Limits والـ Current/Torque Limit.", "افحص الحمل قبل رفع أي Limits."],
    "متوسطة",
    "VFD Inverter drive Current Limit يمنع زيادة السرعة التسارع والسرعة",
  ],
  [
    "vfd-fault-055",
    "التسارع والسرعة",
    "Torque Limit يمنع الحمل",
    "هذا العطل يخص التسارع والسرعة ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Torque Limit يمنع الحمل",
    [C("Limits أو Accel/Decel مو مضبوطة", 45), C("الحمل يحتاج عزم أعلى من المتوفر", 35), C("إعدادات السرعة أو Current/Torque Limit مأثرة", 20)],
    ["راجع Accel/Decel والـ Limits والـ Current/Torque Limit.", "افحص الحمل قبل رفع أي Limits."],
    "متوسطة",
    "VFD Inverter drive Torque Limit يمنع الحمل التسارع والسرعة",
  ],
  [
    "vfd-fault-056",
    "التسارع والسرعة",
    "المحرك يوقف من يزيد الحمل",
    "هذا العطل يخص التسارع والسرعة ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "المحرك يوقف من يزيد الحمل",
    [C("Limits أو Accel/Decel مو مضبوطة", 45), C("الحمل يحتاج عزم أعلى من المتوفر", 35), C("إعدادات السرعة أو Current/Torque Limit مأثرة", 20)],
    ["راجع Accel/Decel والـ Limits والـ Current/Torque Limit.", "افحص الحمل قبل رفع أي Limits."],
    "متوسطة",
    "VFD Inverter drive المحرك يوقف من يزيد الحمل التسارع والسرعة",
  ],
  [
    "vfd-fault-057",
    "التسارع والسرعة",
    "Flying Start ما يمسك المحرك الدائر",
    "هذا العطل يخص التسارع والسرعة ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Flying Start ما يمسك المحرك الدائر",
    [C("Limits أو Accel/Decel مو مضبوطة", 45), C("الحمل يحتاج عزم أعلى من المتوفر", 35), C("إعدادات السرعة أو Current/Torque Limit مأثرة", 20)],
    ["راجع Accel/Decel والـ Limits والـ Current/Torque Limit.", "افحص الحمل قبل رفع أي Limits."],
    "متوسطة",
    "VFD Inverter drive Flying Start ما يمسك المحرك الدائر التسارع والسرعة",
  ],
  [
    "vfd-fault-058",
    "التسارع والسرعة",
    "Flying Start يختار اتجاه غلط",
    "هذا العطل يخص التسارع والسرعة ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Flying Start يختار اتجاه غلط",
    [C("Limits أو Accel/Decel مو مضبوطة", 45), C("الحمل يحتاج عزم أعلى من المتوفر", 35), C("إعدادات السرعة أو Current/Torque Limit مأثرة", 20)],
    ["راجع Accel/Decel والـ Limits والـ Current/Torque Limit.", "افحص الحمل قبل رفع أي Limits."],
    "حرجة",
    "VFD Inverter drive Flying Start يختار اتجاه غلط التسارع والسرعة",
  ],
  [
    "vfd-fault-059",
    "التسارع والسرعة",
    "Skip Frequency يخلي السرعة تقفز",
    "هذا العطل يخص التسارع والسرعة ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Skip Frequency يخلي السرعة تقفز",
    [C("Limits أو Accel/Decel مو مضبوطة", 45), C("الحمل يحتاج عزم أعلى من المتوفر", 35), C("إعدادات السرعة أو Current/Torque Limit مأثرة", 20)],
    ["راجع Accel/Decel والـ Limits والـ Current/Torque Limit.", "افحص الحمل قبل رفع أي Limits."],
    "متوسطة",
    "VFD Inverter drive Skip Frequency يخلي السرعة تقفز التسارع والسرعة",
  ],
  [
    "vfd-fault-060",
    "التسارع والسرعة",
    "Preset Speeds مو صحيحة",
    "هذا العطل يخص التسارع والسرعة ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Preset Speeds مو صحيحة",
    [C("Limits أو Accel/Decel مو مضبوطة", 45), C("الحمل يحتاج عزم أعلى من المتوفر", 35), C("إعدادات السرعة أو Current/Torque Limit مأثرة", 20)],
    ["راجع Accel/Decel والـ Limits والـ Current/Torque Limit.", "افحص الحمل قبل رفع أي Limits."],
    "متوسطة",
    "VFD Inverter drive Preset Speeds مو صحيحة التسارع والسرعة",
  ],
  [
    "vfd-fault-061",
    "Analog / Digital I-O",
    "أمر السرعة ما يوصل للـ VFD",
    "هذا العطل يخص Analog / Digital I-O ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "أمر السرعة ما يوصل للـ VFD",
    [C("Function Assignment أو Scaling مو صحيح", 45), C("السلك أو الـ Common أو مصدر الإشارة بيه مشكلة", 35), C("Noise أو عنصر خارجي متضرر", 20)],
    ["راجع Function Assignment وScaling ومصدر الأمر.", "افحص الأسلاك والـ Common والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive أمر السرعة ما يوصل للـ VFD Analog / Digital I-O",
  ],
  [
    "vfd-fault-062",
    "Analog / Digital I-O",
    "دخل 0-10V يقرا غلط",
    "هذا العطل يخص Analog / Digital I-O ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "دخل 0-10V يقرا غلط",
    [C("Function Assignment أو Scaling مو صحيح", 45), C("السلك أو الـ Common أو مصدر الإشارة بيه مشكلة", 35), C("Noise أو عنصر خارجي متضرر", 20)],
    ["راجع Function Assignment وScaling ومصدر الأمر.", "افحص الأسلاك والـ Common والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive دخل 0-10V يقرا غلط Analog / Digital I-O",
  ],
  [
    "vfd-fault-063",
    "Analog / Digital I-O",
    "دخل 4-20mA يقرا صفر",
    "هذا العطل يخص Analog / Digital I-O ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "دخل 4-20mA يقرا صفر",
    [C("Function Assignment أو Scaling مو صحيح", 45), C("السلك أو الـ Common أو مصدر الإشارة بيه مشكلة", 35), C("Noise أو عنصر خارجي متضرر", 20)],
    ["راجع Function Assignment وScaling ومصدر الأمر.", "افحص الأسلاك والـ Common والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive دخل 4-20mA يقرا صفر Analog / Digital I-O",
  ],
  [
    "vfd-fault-064",
    "Analog / Digital I-O",
    "إشارة 4-20mA تتذبذب",
    "هذا العطل يخص Analog / Digital I-O ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "إشارة 4-20mA تتذبذب",
    [C("Function Assignment أو Scaling مو صحيح", 45), C("السلك أو الـ Common أو مصدر الإشارة بيه مشكلة", 35), C("Noise أو عنصر خارجي متضرر", 20)],
    ["راجع Function Assignment وScaling ومصدر الأمر.", "افحص الأسلاك والـ Common والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive إشارة 4-20mA تتذبذب Analog / Digital I-O",
  ],
  [
    "vfd-fault-065",
    "Analog / Digital I-O",
    "Analog Output مو صحيح",
    "هذا العطل يخص Analog / Digital I-O ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Analog Output مو صحيح",
    [C("Function Assignment أو Scaling مو صحيح", 45), C("السلك أو الـ Common أو مصدر الإشارة بيه مشكلة", 35), C("Noise أو عنصر خارجي متضرر", 20)],
    ["راجع Function Assignment وScaling ومصدر الأمر.", "افحص الأسلاك والـ Common والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive Analog Output مو صحيح Analog / Digital I-O",
  ],
  [
    "vfd-fault-066",
    "Analog / Digital I-O",
    "دخل Run ما يستجيب",
    "هذا العطل يخص Analog / Digital I-O ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "دخل Run ما يستجيب",
    [C("Function Assignment أو Scaling مو صحيح", 45), C("السلك أو الـ Common أو مصدر الإشارة بيه مشكلة", 35), C("Noise أو عنصر خارجي متضرر", 20)],
    ["راجع Function Assignment وScaling ومصدر الأمر.", "افحص الأسلاك والـ Common والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive دخل Run ما يستجيب Analog / Digital I-O",
  ],
  [
    "vfd-fault-067",
    "Analog / Digital I-O",
    "دخل Forward يشتغل وReverse لا",
    "هذا العطل يخص Analog / Digital I-O ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "دخل Forward يشتغل وReverse لا",
    [C("Function Assignment أو Scaling مو صحيح", 45), C("السلك أو الـ Common أو مصدر الإشارة بيه مشكلة", 35), C("Noise أو عنصر خارجي متضرر", 20)],
    ["راجع Function Assignment وScaling ومصدر الأمر.", "افحص الأسلاك والـ Common والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive دخل Forward يشتغل وReverse لا Analog / Digital I-O",
  ],
  [
    "vfd-fault-068",
    "Analog / Digital I-O",
    "Digital Input يبقى ON",
    "هذا العطل يخص Analog / Digital I-O ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Digital Input يبقى ON",
    [C("Function Assignment أو Scaling مو صحيح", 45), C("السلك أو الـ Common أو مصدر الإشارة بيه مشكلة", 35), C("Noise أو عنصر خارجي متضرر", 20)],
    ["راجع Function Assignment وScaling ومصدر الأمر.", "افحص الأسلاك والـ Common والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive Digital Input يبقى ON Analog / Digital I-O",
  ],
  [
    "vfd-fault-069",
    "Analog / Digital I-O",
    "Relay Output ما يغير حالته",
    "هذا العطل يخص Analog / Digital I-O ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Relay Output ما يغير حالته",
    [C("Function Assignment أو Scaling مو صحيح", 45), C("السلك أو الـ Common أو مصدر الإشارة بيه مشكلة", 35), C("Noise أو عنصر خارجي متضرر", 20)],
    ["راجع Function Assignment وScaling ومصدر الأمر.", "افحص الأسلاك والـ Common والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive Relay Output ما يغير حالته Analog / Digital I-O",
  ],
  [
    "vfd-fault-070",
    "Analog / Digital I-O",
    "الـ VFD يشتغل وحده من ترجع الكهرباء",
    "هذا العطل يخص Analog / Digital I-O ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "الـ VFD يشتغل وحده من ترجع الكهرباء",
    [C("Function Assignment أو Scaling مو صحيح", 45), C("السلك أو الـ Common أو مصدر الإشارة بيه مشكلة", 35), C("Noise أو عنصر خارجي متضرر", 20)],
    ["راجع Function Assignment وScaling ومصدر الأمر.", "افحص الأسلاك والـ Common والـ Shielding."],
    "حرجة",
    "VFD Inverter drive الـ VFD يشتغل وحده من ترجع الكهرباء Analog / Digital I-O",
  ],
  [
    "vfd-fault-071",
    "Keypad / Parameters",
    "شاشة الـ VFD مطفية بس أكو تغذية",
    "هذا العطل يخص Keypad / Parameters ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "شاشة الـ VFD مطفية بس أكو تغذية",
    [C("مصدر الأوامر أو الإعدادات مو صحيح", 45), C("Keypad Lock أو Write Protect فعال", 35), C("الكيباد أو ذاكرة الإعدادات بيها مشكلة", 20)],
    ["راجع Local/Remote وLocks والإعدادات.", "احتفظ بنسخة Backup من البراميترات قبل أي Reset."],
    "متوسطة",
    "VFD Inverter drive شاشة الـ VFD مطفية بس أكو تغذية Keypad / Parameters",
  ],
  [
    "vfd-fault-072",
    "Keypad / Parameters",
    "أزرار الكيباد ما تستجيب",
    "هذا العطل يخص Keypad / Parameters ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "أزرار الكيباد ما تستجيب",
    [C("مصدر الأوامر أو الإعدادات مو صحيح", 45), C("Keypad Lock أو Write Protect فعال", 35), C("الكيباد أو ذاكرة الإعدادات بيها مشكلة", 20)],
    ["راجع Local/Remote وLocks والإعدادات.", "احتفظ بنسخة Backup من البراميترات قبل أي Reset."],
    "متوسطة",
    "VFD Inverter drive أزرار الكيباد ما تستجيب Keypad / Parameters",
  ],
  [
    "vfd-fault-073",
    "Keypad / Parameters",
    "Local يشتغل وRemote لا",
    "هذا العطل يخص Keypad / Parameters ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Local يشتغل وRemote لا",
    [C("مصدر الأوامر أو الإعدادات مو صحيح", 45), C("Keypad Lock أو Write Protect فعال", 35), C("الكيباد أو ذاكرة الإعدادات بيها مشكلة", 20)],
    ["راجع Local/Remote وLocks والإعدادات.", "احتفظ بنسخة Backup من البراميترات قبل أي Reset."],
    "متوسطة",
    "VFD Inverter drive Local يشتغل وRemote لا Keypad / Parameters",
  ],
  [
    "vfd-fault-074",
    "Keypad / Parameters",
    "Remote يشتغل وLocal لا",
    "هذا العطل يخص Keypad / Parameters ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Remote يشتغل وLocal لا",
    [C("مصدر الأوامر أو الإعدادات مو صحيح", 45), C("Keypad Lock أو Write Protect فعال", 35), C("الكيباد أو ذاكرة الإعدادات بيها مشكلة", 20)],
    ["راجع Local/Remote وLocks والإعدادات.", "احتفظ بنسخة Backup من البراميترات قبل أي Reset."],
    "متوسطة",
    "VFD Inverter drive Remote يشتغل وLocal لا Keypad / Parameters",
  ],
  [
    "vfd-fault-075",
    "Keypad / Parameters",
    "بيانات المحرك مدخلة غلط",
    "هذا العطل يخص Keypad / Parameters ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "بيانات المحرك مدخلة غلط",
    [C("مصدر الأوامر أو الإعدادات مو صحيح", 45), C("Keypad Lock أو Write Protect فعال", 35), C("الكيباد أو ذاكرة الإعدادات بيها مشكلة", 20)],
    ["راجع Local/Remote وLocks والإعدادات.", "احتفظ بنسخة Backup من البراميترات قبل أي Reset."],
    "متوسطة",
    "VFD Inverter drive بيانات المحرك مدخلة غلط Keypad / Parameters",
  ],
  [
    "vfd-fault-076",
    "Keypad / Parameters",
    "أقصى تردد مضبوط قليل",
    "هذا العطل يخص Keypad / Parameters ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "أقصى تردد مضبوط قليل",
    [C("مصدر الأوامر أو الإعدادات مو صحيح", 45), C("Keypad Lock أو Write Protect فعال", 35), C("الكيباد أو ذاكرة الإعدادات بيها مشكلة", 20)],
    ["راجع Local/Remote وLocks والإعدادات.", "احتفظ بنسخة Backup من البراميترات قبل أي Reset."],
    "متوسطة",
    "VFD Inverter drive أقصى تردد مضبوط قليل Keypad / Parameters",
  ],
  [
    "vfd-fault-077",
    "Keypad / Parameters",
    "أدنى تردد مضبوط عالي",
    "هذا العطل يخص Keypad / Parameters ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "أدنى تردد مضبوط عالي",
    [C("مصدر الأوامر أو الإعدادات مو صحيح", 45), C("Keypad Lock أو Write Protect فعال", 35), C("الكيباد أو ذاكرة الإعدادات بيها مشكلة", 20)],
    ["راجع Local/Remote وLocks والإعدادات.", "احتفظ بنسخة Backup من البراميترات قبل أي Reset."],
    "متوسطة",
    "VFD Inverter drive أدنى تردد مضبوط عالي Keypad / Parameters",
  ],
  [
    "vfd-fault-078",
    "Keypad / Parameters",
    "Carrier Frequency عالي ويسبب حرارة",
    "هذا العطل يخص Keypad / Parameters ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Carrier Frequency عالي ويسبب حرارة",
    [C("مصدر الأوامر أو الإعدادات مو صحيح", 45), C("Keypad Lock أو Write Protect فعال", 35), C("الكيباد أو ذاكرة الإعدادات بيها مشكلة", 20)],
    ["راجع Local/Remote وLocks والإعدادات.", "احتفظ بنسخة Backup من البراميترات قبل أي Reset."],
    "عالية",
    "VFD Inverter drive Carrier Frequency عالي ويسبب حرارة Keypad / Parameters",
  ],
  [
    "vfd-fault-079",
    "Keypad / Parameters",
    "Carrier Frequency واطي ويسبب صوت بالمحرك",
    "هذا العطل يخص Keypad / Parameters ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Carrier Frequency واطي ويسبب صوت بالمحرك",
    [C("مصدر الأوامر أو الإعدادات مو صحيح", 45), C("Keypad Lock أو Write Protect فعال", 35), C("الكيباد أو ذاكرة الإعدادات بيها مشكلة", 20)],
    ["راجع Local/Remote وLocks والإعدادات.", "احتفظ بنسخة Backup من البراميترات قبل أي Reset."],
    "متوسطة",
    "VFD Inverter drive Carrier Frequency واطي ويسبب صوت بالمحرك Keypad / Parameters",
  ],
  [
    "vfd-fault-080",
    "Keypad / Parameters",
    "الإعدادات ما تنحفظ بعد فصل الكهرباء",
    "هذا العطل يخص Keypad / Parameters ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "الإعدادات ما تنحفظ بعد فصل الكهرباء",
    [C("مصدر الأوامر أو الإعدادات مو صحيح", 45), C("Keypad Lock أو Write Protect فعال", 35), C("الكيباد أو ذاكرة الإعدادات بيها مشكلة", 20)],
    ["راجع Local/Remote وLocks والإعدادات.", "احتفظ بنسخة Backup من البراميترات قبل أي Reset."],
    "متوسطة",
    "VFD Inverter drive الإعدادات ما تنحفظ بعد فصل الكهرباء Keypad / Parameters",
  ],
  [
    "vfd-fault-081",
    "Auto Tune / Vector / Encoder",
    "Auto Tune يفشل",
    "هذا العطل يخص Auto Tune / Vector / Encoder ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Auto Tune يفشل",
    [C("بيانات المحرك أو Auto Tune مو صحيحة", 45), C("Encoder أو كيبل Feedback بيه مشكلة", 35), C("إعدادات Vector Loop أو اتجاه Feedback مو صحيحة", 20)],
    ["راجع Motor Data ونوع Auto Tune.", "افحص Encoder وكيبل Feedback والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive Auto Tune يفشل Auto Tune / Vector / Encoder",
  ],
  [
    "vfd-fault-082",
    "Auto Tune / Vector / Encoder",
    "Auto Tune ينجح بس الأداء مو مضبوط",
    "هذا العطل يخص Auto Tune / Vector / Encoder ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Auto Tune ينجح بس الأداء مو مضبوط",
    [C("بيانات المحرك أو Auto Tune مو صحيحة", 45), C("Encoder أو كيبل Feedback بيه مشكلة", 35), C("إعدادات Vector Loop أو اتجاه Feedback مو صحيحة", 20)],
    ["راجع Motor Data ونوع Auto Tune.", "افحص Encoder وكيبل Feedback والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive Auto Tune ينجح بس الأداء مو مضبوط Auto Tune / Vector / Encoder",
  ],
  [
    "vfd-fault-083",
    "Auto Tune / Vector / Encoder",
    "Vector Control ما يثبت السرعة",
    "هذا العطل يخص Auto Tune / Vector / Encoder ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Vector Control ما يثبت السرعة",
    [C("بيانات المحرك أو Auto Tune مو صحيحة", 45), C("Encoder أو كيبل Feedback بيه مشكلة", 35), C("إعدادات Vector Loop أو اتجاه Feedback مو صحيحة", 20)],
    ["راجع Motor Data ونوع Auto Tune.", "افحص Encoder وكيبل Feedback والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive Vector Control ما يثبت السرعة Auto Tune / Vector / Encoder",
  ],
  [
    "vfd-fault-084",
    "Auto Tune / Vector / Encoder",
    "Encoder ما يعطي Feedback",
    "هذا العطل يخص Auto Tune / Vector / Encoder ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Encoder ما يعطي Feedback",
    [C("بيانات المحرك أو Auto Tune مو صحيحة", 45), C("Encoder أو كيبل Feedback بيه مشكلة", 35), C("إعدادات Vector Loop أو اتجاه Feedback مو صحيحة", 20)],
    ["راجع Motor Data ونوع Auto Tune.", "افحص Encoder وكيبل Feedback والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive Encoder ما يعطي Feedback Auto Tune / Vector / Encoder",
  ],
  [
    "vfd-fault-085",
    "Auto Tune / Vector / Encoder",
    "اتجاه الـ Encoder معكوس",
    "هذا العطل يخص Auto Tune / Vector / Encoder ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "اتجاه الـ Encoder معكوس",
    [C("بيانات المحرك أو Auto Tune مو صحيحة", 45), C("Encoder أو كيبل Feedback بيه مشكلة", 35), C("إعدادات Vector Loop أو اتجاه Feedback مو صحيحة", 20)],
    ["راجع Motor Data ونوع Auto Tune.", "افحص Encoder وكيبل Feedback والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive اتجاه الـ Encoder معكوس Auto Tune / Vector / Encoder",
  ],
  [
    "vfd-fault-086",
    "Auto Tune / Vector / Encoder",
    "إشارة الـ Encoder بيها Noise",
    "هذا العطل يخص Auto Tune / Vector / Encoder ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "إشارة الـ Encoder بيها Noise",
    [C("بيانات المحرك أو Auto Tune مو صحيحة", 45), C("Encoder أو كيبل Feedback بيه مشكلة", 35), C("إعدادات Vector Loop أو اتجاه Feedback مو صحيحة", 20)],
    ["راجع Motor Data ونوع Auto Tune.", "افحص Encoder وكيبل Feedback والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive إشارة الـ Encoder بيها Noise Auto Tune / Vector / Encoder",
  ],
  [
    "vfd-fault-087",
    "Auto Tune / Vector / Encoder",
    "عدد Pulses مال Encoder مضبوط غلط",
    "هذا العطل يخص Auto Tune / Vector / Encoder ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "عدد Pulses مال Encoder مضبوط غلط",
    [C("بيانات المحرك أو Auto Tune مو صحيحة", 45), C("Encoder أو كيبل Feedback بيه مشكلة", 35), C("إعدادات Vector Loop أو اتجاه Feedback مو صحيحة", 20)],
    ["راجع Motor Data ونوع Auto Tune.", "افحص Encoder وكيبل Feedback والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive عدد Pulses مال Encoder مضبوط غلط Auto Tune / Vector / Encoder",
  ],
  [
    "vfd-fault-088",
    "Auto Tune / Vector / Encoder",
    "الدرايف يطلع Encoder Loss",
    "هذا العطل يخص Auto Tune / Vector / Encoder ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "الدرايف يطلع Encoder Loss",
    [C("بيانات المحرك أو Auto Tune مو صحيحة", 45), C("Encoder أو كيبل Feedback بيه مشكلة", 35), C("إعدادات Vector Loop أو اتجاه Feedback مو صحيحة", 20)],
    ["راجع Motor Data ونوع Auto Tune.", "افحص Encoder وكيبل Feedback والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive الدرايف يطلع Encoder Loss Auto Tune / Vector / Encoder",
  ],
  [
    "vfd-fault-089",
    "Auto Tune / Vector / Encoder",
    "العزم يتذبذب بوضع Vector",
    "هذا العطل يخص Auto Tune / Vector / Encoder ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "العزم يتذبذب بوضع Vector",
    [C("بيانات المحرك أو Auto Tune مو صحيحة", 45), C("Encoder أو كيبل Feedback بيه مشكلة", 35), C("إعدادات Vector Loop أو اتجاه Feedback مو صحيحة", 20)],
    ["راجع Motor Data ونوع Auto Tune.", "افحص Encoder وكيبل Feedback والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive العزم يتذبذب بوضع Vector Auto Tune / Vector / Encoder",
  ],
  [
    "vfd-fault-090",
    "Auto Tune / Vector / Encoder",
    "المحرك يهتز على السرعات الواطية",
    "هذا العطل يخص Auto Tune / Vector / Encoder ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "المحرك يهتز على السرعات الواطية",
    [C("بيانات المحرك أو Auto Tune مو صحيحة", 45), C("Encoder أو كيبل Feedback بيه مشكلة", 35), C("إعدادات Vector Loop أو اتجاه Feedback مو صحيحة", 20)],
    ["راجع Motor Data ونوع Auto Tune.", "افحص Encoder وكيبل Feedback والـ Shielding."],
    "متوسطة",
    "VFD Inverter drive المحرك يهتز على السرعات الواطية Auto Tune / Vector / Encoder",
  ],
  [
    "vfd-fault-091",
    "PID / Communications",
    "PID ما يثبت الضغط أو التدفق",
    "هذا العطل يخص PID / Communications ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "PID ما يثبت الضغط أو التدفق",
    [C("إعدادات PID أو الاتصال مو متطابقة", 45), C("Feedback أو كيبل الشبكة بيه مشكلة", 35), C("Address/Scaling/Protocol أو Noise مأثر", 20)],
    ["راجع Address/Protocol/Scaling أو PID Settings.", "افحص الكيبلات والـ termination والـ feedback."],
    "متوسطة",
    "VFD Inverter drive PID ما يثبت الضغط أو التدفق PID / Communications",
  ],
  [
    "vfd-fault-092",
    "PID / Communications",
    "PID بطيء كلش",
    "هذا العطل يخص PID / Communications ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "PID بطيء كلش",
    [C("إعدادات PID أو الاتصال مو متطابقة", 45), C("Feedback أو كيبل الشبكة بيه مشكلة", 35), C("Address/Scaling/Protocol أو Noise مأثر", 20)],
    ["راجع Address/Protocol/Scaling أو PID Settings.", "افحص الكيبلات والـ termination والـ feedback."],
    "متوسطة",
    "VFD Inverter drive PID بطيء كلش PID / Communications",
  ],
  [
    "vfd-fault-093",
    "PID / Communications",
    "PID يشتغل بالعكس",
    "هذا العطل يخص PID / Communications ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "PID يشتغل بالعكس",
    [C("إعدادات PID أو الاتصال مو متطابقة", 45), C("Feedback أو كيبل الشبكة بيه مشكلة", 35), C("Address/Scaling/Protocol أو Noise مأثر", 20)],
    ["راجع Address/Protocol/Scaling أو PID Settings.", "افحص الكيبلات والـ termination والـ feedback."],
    "متوسطة",
    "VFD Inverter drive PID يشتغل بالعكس PID / Communications",
  ],
  [
    "vfd-fault-094",
    "PID / Communications",
    "Feedback مال PID مفقود",
    "هذا العطل يخص PID / Communications ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Feedback مال PID مفقود",
    [C("إعدادات PID أو الاتصال مو متطابقة", 45), C("Feedback أو كيبل الشبكة بيه مشكلة", 35), C("Address/Scaling/Protocol أو Noise مأثر", 20)],
    ["راجع Address/Protocol/Scaling أو PID Settings.", "افحص الكيبلات والـ termination والـ feedback."],
    "متوسطة",
    "VFD Inverter drive Feedback مال PID مفقود PID / Communications",
  ],
  [
    "vfd-fault-095",
    "PID / Communications",
    "Modbus ما يتصل ويا الـ VFD",
    "هذا العطل يخص PID / Communications ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Modbus ما يتصل ويا الـ VFD",
    [C("إعدادات PID أو الاتصال مو متطابقة", 45), C("Feedback أو كيبل الشبكة بيه مشكلة", 35), C("Address/Scaling/Protocol أو Noise مأثر", 20)],
    ["راجع Address/Protocol/Scaling أو PID Settings.", "افحص الكيبلات والـ termination والـ feedback."],
    "متوسطة",
    "VFD Inverter drive Modbus ما يتصل ويا الـ VFD PID / Communications",
  ],
  [
    "vfd-fault-096",
    "PID / Communications",
    "Profinet أو Profibus Communication Fault",
    "هذا العطل يخص PID / Communications ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Profinet أو Profibus Communication Fault",
    [C("إعدادات PID أو الاتصال مو متطابقة", 45), C("Feedback أو كيبل الشبكة بيه مشكلة", 35), C("Address/Scaling/Protocol أو Noise مأثر", 20)],
    ["راجع Address/Protocol/Scaling أو PID Settings.", "افحص الكيبلات والـ termination والـ feedback."],
    "متوسطة",
    "VFD Inverter drive Profinet أو Profibus Communication Fault PID / Communications",
  ],
  [
    "vfd-fault-097",
    "PID / Communications",
    "Ethernet IP Communication Fault",
    "هذا العطل يخص PID / Communications ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "Ethernet IP Communication Fault",
    [C("إعدادات PID أو الاتصال مو متطابقة", 45), C("Feedback أو كيبل الشبكة بيه مشكلة", 35), C("Address/Scaling/Protocol أو Noise مأثر", 20)],
    ["راجع Address/Protocol/Scaling أو PID Settings.", "افحص الكيبلات والـ termination والـ feedback."],
    "متوسطة",
    "VFD Inverter drive Ethernet IP Communication Fault PID / Communications",
  ],
  [
    "vfd-fault-098",
    "PID / Communications",
    "CANopen Communication Fault",
    "هذا العطل يخص PID / Communications ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "CANopen Communication Fault",
    [C("إعدادات PID أو الاتصال مو متطابقة", 45), C("Feedback أو كيبل الشبكة بيه مشكلة", 35), C("Address/Scaling/Protocol أو Noise مأثر", 20)],
    ["راجع Address/Protocol/Scaling أو PID Settings.", "افحص الكيبلات والـ termination والـ feedback."],
    "متوسطة",
    "VFD Inverter drive CANopen Communication Fault PID / Communications",
  ],
  [
    "vfd-fault-099",
    "PID / Communications",
    "الدرايف يفصل من ينقطع الاتصال",
    "هذا العطل يخص PID / Communications ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "الدرايف يفصل من ينقطع الاتصال",
    [C("إعدادات PID أو الاتصال مو متطابقة", 45), C("Feedback أو كيبل الشبكة بيه مشكلة", 35), C("Address/Scaling/Protocol أو Noise مأثر", 20)],
    ["راجع Address/Protocol/Scaling أو PID Settings.", "افحص الكيبلات والـ termination والـ feedback."],
    "متوسطة",
    "VFD Inverter drive الدرايف يفصل من ينقطع الاتصال PID / Communications",
  ],
  [
    "vfd-fault-100",
    "PID / Communications",
    "الأوامر توصل بس السرعة ما تتغير عبر الشبكة",
    "هذا العطل يخص PID / Communications ويظهر على الـ VFD أو على تشغيل المحرك بصورة غير طبيعية.",
    "الأوامر توصل بس السرعة ما تتغير عبر الشبكة",
    [C("إعدادات PID أو الاتصال مو متطابقة", 45), C("Feedback أو كيبل الشبكة بيه مشكلة", 35), C("Address/Scaling/Protocol أو Noise مأثر", 20)],
    ["راجع Address/Protocol/Scaling أو PID Settings.", "افحص الكيبلات والـ termination والـ feedback."],
    "متوسطة",
    "VFD Inverter drive الأوامر توصل بس السرعة ما تتغير عبر الشبكة PID / Communications",
  ],
];

export const vfdFaults: VfdFault[] = rows.map(([id,device_ar,name_ar,description_ar,symptom,causes,solutions,severity,keywords]) => ({
  id,
  category_id: null,
  device_ar,
  name_ar,
  description_ar,
  symptoms: [symptom],
  causes,
  tests: [{
    test: "الفحص الأولي",
    location: device_ar,
    method: "افصل وعزل التغذية، وانتظر زمن تفريغ الـ DC Bus المكتوب من الشركة قبل فتح الـ VFD أو لمس ترمنلات القدرة. القياسات على دوائر حية أو فحص IGBT/Rectifier/DC Bus خليه لفني مختص.",
    normal: "الفولت والتيار والسرعة ضمن الطبيعي، وماكو حرارة عالية أو حرك أو Fault متكرر.",
    faulty: "وجود Overcurrent أو Ground Fault أو فاز مفقود أو حرارة عالية أو DC Bus غير طبيعي يدل على عطل يحتاج تشخيص قبل إعادة التشغيل.",
  }],
  solutions,
  severity,
  safety_warnings: severity === "حرجة" ? [
    "تنبيه: داخل الـ VFD أكو فولت DC خطير ممكن يبقى بعد فصل الكهرباء. انتظر زمن التفريغ حسب المصنع قبل لمس الدائرة.",
    "لا تفصل أو توصل المحرك أو مقاومة الفرملة والـ VFD ينتج خرج. الفحص الداخلي خليه لفني مؤهل.",
  ] : [
    "افصل وعزل التغذية قبل فك الأسلاك أو إعادة الربط.",
    "إذا شفت شرر أو ذوبان أو شميت ريحة حرك، وقف المعدة وخلي فني يفحصها.",
  ],
  error_code: null,
  keywords,
  next_question_key: null,
}));
